import React from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { DEAFAULT_PAGESIZE, setPayloadForFetchSoundLists } from "..";
import { Loader2 } from "../../../../../../util/loading";
import { actions } from "../../../../../Dashboard/_redux/dashboardRedux";
import {
  fetchTTSSoundsLists,
  multiSoundUpload,
  setCurrentPage,
  setSoundListingApiPayload,
} from "../../../../state/slices/soundsSlice";
import BrowseSoundFile from "./BrowseSoundFile";
import SaveSoundAndCancel from "./SaveSoundAndCancel";

const AddInBulk = ({ handleCloseUploadSounds, setToastValue }) => {
  const { activeSoundTab, pageSize, searchQuery, currentPage } = useSelector(
    (state) => state.soundsSlice
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      soundFile: "",
    },
    validationSchema: Yup.object().shape({
      soundFile: Yup.mixed()
        .required("Please choose a sound file.")
        .test(
          "fileSize",
          "The total file(s) size exceeding the max size limit of 10MB",
          (value) => {
            if (!value) return true;
            let filesSize = 0;
            if (value && value?.length > 0) {
              for (let i = 0; i < value.length; i++) {
                filesSize += value[i].size;
              }
              if (filesSize > 10485760) {
                return false;
              }
            }
            return true;
          }
        )
        .test(
          "FILE_FORMAT",
          `Invalid type file. Only '.mp3 or .wav' files are supported.`,
          (value) => {
            if (!value) return true;
            if (value && value?.length > 0) {
              for (let i = 0; i < value.length; i++) {
                if (!["audio/mpeg", "audio/wav"].includes(value[i].type)) {
                  return false;
                }
              }
            }
            return true;
          }
        )
        .test(
          "fileCount",
          "Too many files selected. Please select up to 10 files.",
          (value) => {
            if (!value) return true;
            if (value && value?.length > 10) {
              return false;
            }
            return true;
          }
        ),
    }),
    onSubmit: (values, { resetForm }) => {
      let assumeId = localStorage.getItem("assume_id");
      assumeId = (assumeId === 'null' || assumeId === '' || assumeId === 'None') ? false : assumeId;
      const formData = new FormData();
      [...values.soundFile].forEach((sound) => {
        formData.append("multisoundfile", sound);
      });
      formData.append("status", assumeId ? 1 : 0);
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loading",
        })
      );

      dispatch(multiSoundUpload(formData)).then((response) => {
        if (response.error) {
          const {
            payload: { error },
          } = response;
          if (error?.response?.data?.msg)
            setToastValue(
              true,
              error.response.data.msg.replace(/^"(.*)"$/, "$1"),
              "error"
            );
        } else {
          const {
            payload: {
              data: { msg },
            },
          } = response;
          if (Array.isArray(msg)) {
            setToastValue(true, msg[0], "success");
          } else {
            setToastValue(true, msg, "error");
          }

          let payload = setPayloadForFetchSoundLists(
            1,
            pageSize,
            activeSoundTab
          );
          payload = {
            ...payload,
            ...(searchQuery && {
              soundlibobj__soundname__icontains: searchQuery,
            }),
          };
          if (currentPage > 1) {
            dispatch(setSoundListingApiPayload(payload));
            dispatch(setCurrentPage(1));
          } else {
            dispatch(fetchTTSSoundsLists(payload));
          }
          handleCloseUploadSounds();
        }
      });
    },
  });

  const dispatch = useDispatch();

  return (
    <div className="pr-10 w-100">
      <Loader2 resource="upload_sound" />

      <form className="form" onSubmit={formik.handleSubmit}>
        <div>
          <BrowseSoundFile uploadMultiple={true} formikValue={formik} />
        </div>
        <SaveSoundAndCancel handleCloseUploadSounds={handleCloseUploadSounds} />
      </form>
    </div>
  );
};

export default AddInBulk;
